import Vue from 'vue';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';

Vue.use(Notifications, { velocity });

export default Notifications;



// WEBPACK FOOTER //
// ./src/notifications.js